export default "__VITE_ASSET__EndUnq1l__"